import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/hydrological';

const options = {
  cache: {
    maxAge: 60 * 60 * 1000,
    exclude: { query: false }
  }
}

const loadQuotas = async ({organization_ids,station_ids}) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, {organization_ids,station_ids});
  return api.get(url, options);
}

export {
  loadQuotas,
}
